import { Navigate } from 'react-router-dom';

const IntegrationList = async () =>
    import('../../pages/integrations/List').then((module) => ({ Component: module.IntegrationsList }));

export const getIntegrationsRoutes = (user) => {
    if (user?.carrierId) return [];

    return [
        {
            path: '/integrations/',
            element: <Navigate to='/integrations/jobs/' />,
            redirectFrom: ['/integrations'],
        },
        {
            path: '/integrations/jobs/',
            lazy: IntegrationList,
        },
        {
            path: '/integrations/jobs/view/:viewId',
            lazy: IntegrationList,
        },
        {
            path: '/integrations/api-calls/',
            lazy: IntegrationList,
        },
        {
            path: '/integrations/api-calls/view/:viewId',
            lazy: IntegrationList,
        },
    ];
};
